<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      />
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      @click="change(localeObj)"
    >
      <b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      />
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BImg } from 'bootstrap-vue'

export default {
  components: {
    BNavItemDropdown,
    BImg,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      data: {}
    }
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      const loc = this.$i18n.locale || localStorage.getItem('CurrentLocal') || 'fa'
      return this.locales.find(l => l.locale === loc) || this.locales[0]
    },
  },
  created() {
    // this.getUserRole()
  },
  methods: {
    change(localeObj) {
      this.$i18n.locale = localeObj.locale
      localStorage.setItem('CurrentLocal', localeObj.locale)
      localStorage.setItem('locale_initialized_fa', 'true')
      window.location.reload()
    },
    getUserRole() {
      console.log(this.userData)
      this.loading = true
      this.$http.post(
          this.$api.userrole.get, {
            Id: this.userData.ID,
          },
      )
          .then(res => {
            this.loading = false
            this.data = res.data
          })
    },
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [
      {
        locale: 'fa',
        img: require('@/assets/images/flags/fa.png'),
        name: 'فارسی',
      },
      {
        locale: 'en',
        img: require('@/assets/images/flags/en.png'),
        name: 'انگلیسی',
      },
      {
        locale: 'ar',
        img: require('@/assets/images/flags/ar.png'),
        name: 'عربی',
      },
    ]
    /* eslint-disable global-require */

    return {
      locales,
    }
  },
}
</script>

<style>

</style>
